
import UserEdit from '../../components/UserEdit/UserEdit'

const EditUserPage = () => {

    return (

        <UserEdit />

    )
}
export default EditUserPage